import * as React from 'react';
export const MFSvg = React.forwardRef(function MFSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M2 2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3V2H2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M11 2v12h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-3Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M5 2h6v12H5z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EAEEF3',
      d: 'M5 14v-1h6v1H5ZM5 2h6v1H5V2Z',
    }),
  );
});
MFSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  fill: 'none',
  viewBox: '0 0 16 16',
};
export var MF = {
  category: 'flag',
  colorable: false,
  name: 'MF',
  svg: MFSvg,
};
